import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import {AngularFireDatabase} from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent {

 

userDetails:any={};
  constructor(private route: ActivatedRoute,  public router: Router, public af: AngularFireDatabase,public authentication: AngularFireAuth) {

       this.af.object('/users');
  }
    onAddUsers(form: NgForm){
          console.log("Users Data : "+JSON.stringify(this.userDetails));
         this.authentication.auth.createUserWithEmailAndPassword(this.userDetails.email, this.userDetails.password)
      .then(success => {
             this.af.object('/users/'+ success.auth.uid).update({
             	   email:this.userDetails.email,
      	        name:this.userDetails.name,
      	        mobileNo:this.userDetails.mobileNo,
                role:'User'
        }).then((res)=>{
      	console.log("Success");
      	 this.router.navigate(['/users/manageUsers'])
      })
   })

}
  cancel(){
        this.router.navigate(['/users/manageUsers'])
    }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/users/add-user/add-user.component.ts